import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { SERVER_URL } from '../../api/url';
import useStore from '../../store/information';

const ZoomQuotationForm = ({ courseID, courseName }) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { Name,Id } = useStore();


  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset
  } = useForm();

  useEffect(() => {
    const userName = localStorage.getItem('userName') || '';
    const userEmail = localStorage.getItem('userEmail') || '';
    const userPhoneNumber = localStorage.getItem('userPhoneNumber') || '';

 setValue("course", Name);
    // Set default values in the form
    setValue("name", userName);
    setValue("email", userEmail);
    setValue("phNumber", userPhoneNumber);
  }, [setValue]);

  const handleCreateSubmit = async (data) => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append('name', data.name);
      formData.append('description', data.phNumber);
      formData.append('course', courseID || Id);

      if (file) {
        formData.append('payment', file);
      }

      const token = localStorage.getItem("userToken");

      const response = await axios.post(`${SERVER_URL}/payment/request_payment`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': token,
        },
      });

      setMessage(response?.data?.data);
      setError("");
      reset();
      setFile(null);
    } catch (err) {
      console.error('Error submitting form:', err.response);
      setError(err?.response?.data?.error);
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && !selectedFile.type.startsWith('image/')) {
      alert('Please upload a valid image file.');
      return;
    }

    if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
      alert('File size exceeds 5MB limit.');
      return;
    }

    setFile(selectedFile);
  };

  return (
    <div className="row d-flex justify-content-center">
      <form className="d-flex flex-column gap-3 w-100" onSubmit={handleSubmit(handleCreateSubmit)}>
  <div className="input-container">
          <label className="input-label" htmlFor="email">
            Course Name: <span className="require-star">*</span>
          </label>
          <input
            type="course"
            className="form-control"
            id="course"
            {...register('course')}
            readOnly
          />
        </div>
        {/* Name */}
        <div className="input-container">
          <label className="input-label" htmlFor="name">
            Full Name: <span className="require-star">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            {...register('name', {
              required: 'Name is required',
              minLength: { value: 4, message: 'Name should be at least 4 characters long' },
              maxLength: { value: 40, message: 'Name should be no longer than 40 characters' }
            })}
          />
          {errors.name && <div className="error-message">{errors.name.message}</div>}
        </div>

        {/* Email (read-only) */}
        <div className="input-container">
          <label className="input-label" htmlFor="email">
            Email address: <span className="require-star">*</span>
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            {...register('email')}
            readOnly
          />
        </div>

        {/* Phone Number */}
        <div className="input-container">
          <label className="input-label" htmlFor="phNumber">
            Phone Number: <span className="require-star">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="phNumber"
            {...register('phNumber', {
              required: 'Phone number is required',
              minLength: { value: 5, message: 'Phone number should be at least 5 characters long' },
              maxLength: { value: 15, message: 'Phone number should be no longer than 15 characters' }
            })}
          />
          {errors.phNumber && <div className="error-message">{errors.phNumber.message}</div>}
        </div>

        {/* Payment Screenshot */}
        <div className="input-container">
          <label className="input-label" htmlFor="snapShot">
            Upload Payment Screenshot: <span className="require-star">*</span>
          </label>
          <input
            type="file"
            className="form-control"
            id="snapShot"
            accept="image/*"
            onChange={handleFileChange}
            required
          />
        </div>

        {/* Alerts */}
        {message && (
          <div className="alert alert-info">
            {message}
            <p>Please download our app. After admin approval, you can access video lessons there.</p>
          </div>
        )}
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {/* Submit Button */}
       <button type="submit" className="btn btn-primary btn-lg px-4" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default ZoomQuotationForm;
